/* @flow */
import { takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { loadQuickActionsForGroup } from 'entities/QuickActions';
import { loadQuickActionsSuccess } from 'reducers/quickActions';
import type { loadQuickActionsAction } from 'reducers/quickActions';

function* fetchQuickActions(action: loadQuickActionsAction): Generator<?any, ?any, ?any> {
  try {
    const quickActions = yield call(loadQuickActionsForGroup, action.groupId);
    if (quickActions) {
      yield put(loadQuickActionsSuccess(action.groupId, quickActions));
    }
  } catch (e) {
    console.error(e);
  }
}

export default function* loadQuickActions(): Generator<?any, ?any, ?any> {
  // $FlowFixMe
  yield* takeLatest('quickActions/LOAD_QUICK_ACTIONS', fetchQuickActions);
}



// WEBPACK FOOTER //
// ./src/sagas/quickActions.js